const Glide = window.Glide;
import { disableIfGlideFit, setButtonsVisibility } from "../../Scripts/glideControls.js";
(() => {
    const sliders = document.querySelectorAll(".block__restaurantListing  .glide");
    const handleViewMoreRestaurants = (event) => {
        // remove hidden rows
        const glideSlidesElm = event.currentTarget.parentElement.parentElement.querySelector(".glide__slides");
        if(glideSlidesElm) {
            glideSlidesElm.style = "grid-auto-rows: unset;";
        }
        // hide self
        event.currentTarget.style.display = "none";
    }
    let glides = [];
    const options = {
        perView: 4,
        peek: { before: 0, after: 91 },
        bound: true,
        gap: 16,
        breakpoints: {
            500: {
                perView: 1,
                peek: { before: 0, after: 70 },
                gap: 16,
            },
            649: {
                perView: 2,
                peek: { before: 0, after: 70 },
                gap: 16,
            },
            767: {
                perView: 2,
                peek: { before: 0, after: 186 },
                gap: 16,
            },
            1023: {
                perView: 3,
                peek: { before: 0, after: 80},
                gap: 16,
            },
            1365: {
                perView: 4,
                dragThreshold: false,
                gap: 16,
                peek: { before: 0, after: 150 },
            },
        },
    };

    for (let i = 0; i < glides.length; i++) {
        disableIfGlideFit(glides[i]);
    }
    const disableSlidesBasedOnView = () => {
        if (window.Foundation.MediaQuery.atLeast("large")) {
            if (glides.length === 0) {
                return;
            }
            glides.forEach(glide => glide.destroy());
            glides = [];
        } else {
            if (glides.length !== 0) {
                return;
            }
            sliders.forEach((slider) => {
                let glide = new Glide(slider, options);
                glide.on("move.after", () => {
                    let firstButton = glide.selector.querySelector(".button__glide.button__prev");
                    let lastButton = glide.selector.querySelector(".button__glide.button__next");
                    let numOfSlides = glide.selector.querySelectorAll(".glide__slide").length;
                    setButtonsVisibility(glide, firstButton, lastButton, numOfSlides);
                });
                glides.push(glide.mount());
            });
        }
    }
    disableSlidesBasedOnView();
    
    if(sliders) {
        window.addEventListener("resize", () => {
            //disable glides at certain screen sizes (large and up in this case)
            disableSlidesBasedOnView();
            // disable glides if there is not enough slides to overflow screen
            for (let i = 0; i < glides.length; i++) {
                disableIfGlideFit(glides[i]);
            }
            //reset view more button if activated and beneath a certain size
            if (!window.Foundation.MediaQuery.atLeast("large")) {
                const viewMoreButtons = document.querySelectorAll(".block__restaurantListing .button__viewMore");
                viewMoreButtons.forEach(viewMoreButton => {
                    if (viewMoreButton.style.display === "none") {
                        viewMoreButton.style.display = "";
                        const glideSlidesElm = viewMoreButton.parentElement.parentElement.querySelector(".glide__slides");
                        if(glideSlidesElm) {
                            glideSlidesElm.style = "";
                        }                
                    }
                })
            }
        });
    }
    window.handleViewMoreRestaurants = handleViewMoreRestaurants;
})();